import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { KYMW1709Component } from "./kymw1709.component";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { GetUploadImageInfoService } from "./api-services/get-upload-image-info.service";

/**
 * アップロード画像確認　モジュール設定クラス
 */
@NgModule({
  imports: [
    AppCommonsModule,
    CommonModule,
    FormsModule,
    PlessSharedModule
  ],
  declarations: [
    KYMW1709Component
  ],
  providers: [
    GetUploadImageInfoService,
  ]
})

export class KYMW1709Module {}